export enum LocaleEnum {
  EN_US = 'en-us',
  ES = 'es',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
  NL = 'nl',
  AR = 'ar',
}
